<template>
  <div
    class="template date"
    v-show="dataVal.IsShow || dataVal.IsShow == null"
    v-if="dataVal.MinDate == null"
  >
    <div class="panel_wrap">
      <label class="panel_title"
        >{{ dataVal.Property.Title[0].Text
        }}<span v-show="dataVal.Property.Require == 1" class="require">*</span>
      </label>
      <!-- <input class="input_value" :disabled="dataVal.Disable" :value="dataVal.Value" type="date" :placeholder="dataVal.Placeholder" /> -->
      <div class="input_value">
        <el-date-picker
          ref="mydate"
          :disabled="dataVal.Disable"
          v-model="dataVal.Value"
          align="right"
          style="width: 100%"
          format="yyyy-MM-dd HH:mm:ss"
          :picker-options="pickerOptions"
          @change="changeVal"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetime"
          placeholder="选择日期时间"
        ></el-date-picker>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["dataVal"],
  data() {
    return {
      pickerOptions: {
        disabledDate: null,
      },
    };
  },
  created() {
	let text = this.dataVal.Property.Title[0].Text
    if(text === "借用开始时间" || text === "借用结束时间"){
		this.pickerOptions.disabledDate = time => {
		  let d = new Date()
		  d.setDate(d.getDate() - 1)
		  return (time.getTime() > new Date(this.addDate(d,7)))||(time.getTime() < d)&&
		      time.getTime() !==new Date()
		}
	}
  },
  mounted() {},
  methods: {
    forbid() {
      //禁止软键盘弹出
      document.activeElement.blur();
    },
    /**
     * 添加天数
     * @param arg
     * @param days
     * @returns {string}
     */
    addDate(arg, days) {
      if (days === undefined || days === "") {
        days = 1;
      }
      var date = new Date(arg);
      date.setDate(date.getDate() + days);
      var month =
        date.getMonth() + 1 > 9
          ? date.getMonth() + 1
          : `0${date.getMonth() + 1}`;
      var day = date.getDate() > 9 ? date.getDate() : `0${date.getDate()}`;
      var hours = date.getHours() > 9 ? date.getHours() : `0${date.getHours()}`;
      var minutes =
        date.getMinutes() > 9 ? date.getMinutes() : `0${date.getMinutes()}`;
      var seconds =
        date.getSeconds() > 9 ? date.getSeconds() : `0${date.getSeconds()}`;
      return `${date.getFullYear()}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    changeVal(val) {
      if (this.dataVal.Property.Title[0].Text === "借用结束时间" || this.dataVal.Property.Title[0].Text === "借用开始时间"){
		this.$emit("child-event",this.dataVal,"资源借用");
      }
    },
  },
};
</script>

<style scoped lang="less">
@import "../assets/css/common.css";
</style>
